// Shared grocery-delivery calculation & formatting methods.
// Expects `documentTransactions` (Array) to be present on the component
// (as a computed property or a prop).
export default {
  methods: {
    getGroceryTransactions(grocery) {
      return (this.documentTransactions || []).filter((t) => t.grocery_id === grocery.id);
    },
    getGroceryDelivered(grocery) {
      return this.getGroceryTransactions(grocery).reduce(
        (sum, t) => sum + Number(t.amount),
        0
      );
    },
    getRemaining(grocery) {
      return Math.max(Number(grocery.amount) - this.getGroceryDelivered(grocery), 0);
    },
    isFullyDelivered(grocery) {
      return this.getRemaining(grocery) <= 0;
    },
    getCurrentReceiptAmount(grocery) {
      return Math.max(Number(grocery.order) || 0, 0);
    },
    getCurrentGrossQuantity(grocery) {
      return Number(grocery.gross_quantity) || this.getCurrentReceiptAmount(grocery);
    },
    getCurrentUnitPrice(grocery) {
      return Number(grocery.unit_price) || 0;
    },
    getCurrentLineValue(grocery) {
      const qty = this.isFullyDelivered(grocery)
        ? this.getGroceryDelivered(grocery)
        : this.getCurrentReceiptAmount(grocery);
      return qty * this.getCurrentUnitPrice(grocery);
    },
    formatMoney(amount) {
      return `${(Number(amount) || 0).toFixed(2)} ${this.restaurantCurrency}`;
    },
    formatPlainQuantity(amount) {
      return Number(amount) || 0;
    },
    formatOptionalQuantity(amount) {
      const n = Number(amount) || 0;
      return n === 0 ? "" : n;
    },
    formatQuantity(amount, measure) {
      return measure ? `${Number(amount) || 0} ${measure}` : Number(amount) || 0;
    },
    formatOptionalMoney(amount) {
      return Number(amount) === 0 ? "" : (Number(amount) || 0).toFixed(2);
    },
    getReceiptRowClass(item) {
      return this.isFullyDelivered(item)
        ? "receipt-table-row receipt-table-row--completed"
        : "receipt-table-row";
    },
  },
};
